import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, untracked } from '@angular/core';
import { NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';
import { DateOnly } from '../../core';
import { MotMessagesData } from '../../models';
import { ContactInfoComponent, MotivationalMessagesComponent, PinSiteCareComponent } from '../../patient';
import { PublishService } from '../../services';
import { BaseComponent } from '../../shared';


/**
 * Component for patient settings tab of publish page.
 */
@Component({
	selector: 'tsp-publish-patient',
	imports: [
		CommonModule,
		NgbCollapseModule,
		ContactInfoComponent,
		PinSiteCareComponent,
		MotivationalMessagesComponent
	],
	templateUrl: './publish-patient.component.html',
	changeDetection: ChangeDetectionStrategy.Eager
})
export class PublishPatientComponent extends BaseComponent {

	private readonly pubSrv = inject(PublishService);

	contactInfo = computed(() => this.pubSrv.patSettings()?.email ?? null);
	secondContactInfo = computed(() => this.pubSrv.patSettings()?.secondEmail ?? null);
	isContactInfoValid = this.pubSrv.isContactInfoValid;

	isPinSiteCareEnabled = computed(() => this.pubSrv.patSettings()?.pinSiteCareEnable ?? false);
	firstDay = computed(() => this.pubSrv.patSettings()?.firstDay);
	frequency = computed(() => this.pubSrv.patSettings()?.frequency);
	isPinSiteCareValid = this.pubSrv.isPinSiteCareValid;

	motMessagesData = computed<MotMessagesData | undefined>(() => {
		const stgs = this.pubSrv.patSettings();
		if (!stgs) return undefined;
		return {
			userId: untracked(this.pubSrv.plan)!.userGuid,
			enabled: stgs.mmEnable,
			customSet: stgs.customSet,
			enableSet: stgs.enabledSet
		} as MotMessagesData;
	});
	isMotMessagesValid = this.pubSrv.isMotMessagesValid;

	// pinSiteCarePdf = computed(() => this.pubSrv.patSettings()?.pinSiteCarefile?.name);
	// physiotherapyPdf = computed(() => this.pubSrv.patSettings()?.physiotherapyfile?.name);

	// pdfPinSiteCareOpened = false;
	msgOpened = false;
	// pdfPhysioOpened = false;


	/**
	 * Update email address.
	 */
	updateEmail(email: string | null): void {
		if (this.isContactInfoValid() && email) {
			this.pubSrv.patSettings()!.email = email;
		}
	}

	/**
	 * Update second email address.
	 */
	updateSecondEmail(email: string | null): void {
		if (this.isContactInfoValid()) {
			this.pubSrv.patSettings()!.secondEmail = email?.length ? email : null;
		}
	}

	/**
	 * Enable Pin Site Care.
	 */
	enablePinSiteCare(val: boolean): void {
		this.pubSrv.patSettings()!.pinSiteCareEnable = val;
	}

	/**
	 * Update First Day.
	 */
	updateFirstDay(date?: Date | null): void {
		this.pubSrv.patSettings()!.firstDay = date ? new DateOnly(date) : undefined;
	}

	/**
	 * Update frequency.
	 */
	updateFrequency(freq: boolean[] | undefined): void {
		this.pubSrv.patSettings()!.frequency = freq;
	}

	/**
	 * Enable Motivational Messages.
	 */
	enableMotMessages(val: boolean): void {
		this.pubSrv.patSettings()!.mmEnable = val;
	}

	/**
	 * Update custom set.
	 */
	updateCustomSet(set: string | null): void {
		this.pubSrv.patSettings()!.customSet = set ?? undefined;
	}

	/**
	 * Update enable set.
	 */
	updateEnableSet(set: number[] | undefined): void {
		this.pubSrv.patSettings()!.enabledSet = set;
	}

	/**
	 * Update PinSiteCare file.
	 */
	// updatePinSiteCareFile(file: { name: string; data: string; } | null): void {
	// 	this.pubSrv.patSettings()!.pinSiteCarefile = file ? { ...file, category: FileCategory.PINSITECARE } : undefined;
	// }

	/**
	 * Update Physiotherapy file.
	 */
	// updatePhysiotherapyFile(file: { name: string; data: string; } | null): void {
	// 	this.pubSrv.patSettings()!.physiotherapyfile = file ? { ...file, category: FileCategory.PHYSIOTHERAPY } : undefined;
	// }

}
